import PaymentRow from "../../payment/admin/component/PaymentRow";
import {
  Table as GridTable,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Paper,
  Grid
} from "@mui/material";
import { useUserState } from "../../../context/UserContext";
import logo from "../../../assets/images/logo.svg";
import UnpaidStamp from "../../../assets/images/unpaid.png";
import PaidStamp from "../../../assets/images/paidStamp.webp";
import useStyles from "../styles";

const ViewInvoice = () => {
  const classes = useStyles();
  const { appLogo } = useUserState();

  const aStudentInvoice = {
    status: "unpaid",
    invoice_no: "INV-2025-0345",
    invoice_name: "Pro Plan Subscription - July 2025",
    total: 34000,
    payment_method: [{ currency: "NGN" }],
    session: { name: "2025" },
    term: { name: "Annual Plan" },
    student: {
      id: "admin-001",
      first_name: "School",
      last_name: "Admin"
    },
    created_at: "2025-07-13",
    due_date: "2025-07-20",
    fee_items: [
      {
        item: "Pro Plan Subscription",
        amount: 34000
      }
    ],
    description: "Invoice for your Pro Plan subscription (July 2025) with full access to premium features, reporting tools, and priority support."
  };

  return (
    <div>
      <div className={`${classes.previewheader} margin-top-30`}>
        <div className={classes.logoContent}>
          <img
            src={appLogo || logo}
            alt="App Logo"
            className={classes.logoContent}
          />
        </div>
        <div className="flex gap-10 align-items-center flex-item-reverse-413">
          {aStudentInvoice?.status === "success" ? (
            <div className={classes.logoContent}>
              <img
                src={PaidStamp}
                alt="PaidStamp Logo"
                className={classes.logoContent}
              />
            </div>
          ) : (
            <div className={classes.logoContent}>
              <img
                src={UnpaidStamp}
                alt="UnpaidStamp Logo"
                className={classes.logoContent}
              />
            </div>
          )}
          <div className="text-align-left-413 ">
            <p>Invoice Number</p>
            <h4>#{aStudentInvoice?.invoice_no || "--/--"}</h4>
          </div>
        </div>
      </div>
      <div className={`${classes.previewheader} margin-top-13 margin-bottom-40`}>
        <div>
          <p className="text-align-left margin-top-12">Invoice Name</p>
          <h4>{aStudentInvoice?.invoice_name || "--/--"}</h4>
        </div>
        <div className="text-align-right">
          <p className="text-align-left-413">Amount</p>
          <h3>{`${aStudentInvoice?.total?.toLocaleString()} ${aStudentInvoice?.payment_method?.[0]?.currency}` || "NGN"}</h3>
        </div>
      </div>
      <Grid container spacing={2}>
        <Grid item lg={4} md={4} sm={4} xs={6}>
          <div className={`${classes.previewsubheader} text-align-left`}>
            <div>
              <p>Year</p>
              <h4>{aStudentInvoice?.session?.name || "--/--"}</h4>
            </div>
          </div>
        </Grid>
        <Grid item lg={4} md={4} sm={4} xs={6}>
          <div className={`${classes.previewsubheader} text-align-left`}>
            <div>
              <p>Plan</p>
              <h4>{aStudentInvoice?.term?.name || "--/--"}</h4>
            </div>
          </div>
        </Grid>
        <Grid item lg={4} md={4} sm={4} xs={12}>
          <div className={`${classes.previewsubheader} text-align-left`}>
            <div>
              <p>Invoiced To</p>
              <h4 className="text-align-left cursor-pointer">
                {`${aStudentInvoice?.student?.last_name || "--/--"} ${aStudentInvoice?.student?.first_name || "--/--"}`}
              </h4>
            </div>
          </div>
        </Grid>
        <Grid item lg={4} md={4} sm={4} xs={12}>
          <div className={`${classes.previewsubheader} text-align-left`}>
            <div>
              <p>Created On</p>
              <h4>{aStudentInvoice?.created_at || "--/--"}</h4>
            </div>
          </div>
        </Grid>
        <Grid item lg={4} md={4} sm={4} xs={12}>
          <div className={`${classes.previewsubheader} text-align-left`}>
            <div>
              <p>Due On</p>
              <h4>{aStudentInvoice?.due_date || "--/--"}</h4>
            </div>
          </div>
        </Grid>
      </Grid>
      <TableContainer component={Paper} style={{ overflowX: "auto", marginTop: "40px" }} className="payment-table">
        <GridTable>
          <TableHead>
            <TableRow>
              <TableCell>Item</TableCell>
              <TableCell>Payment Method</TableCell>
              <TableCell>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{ textAlign: "left" }}>
            {aStudentInvoice?.fee_items?.map((payment, index) => (
              <PaymentRow
                key={index}
                item={payment?.item || "--/--"}
                paymentMethods={aStudentInvoice?.payment_method}
                amount={payment?.amount}
                ItemCurrency={aStudentInvoice?.payment_method || "NGN"}
              />
            ))}
          </TableBody>
          <TableFooter style={{ backgroundColor: "#F9FAFB" }}>
            <TableRow>
              <TableCell colSpan={2} style={{ textAlign: "left", fontWeight: "700", fontSize: "14px", padding: "24px" }}>
                                          Total
              </TableCell>
              <TableCell style={{ textAlign: "right", fontWeight: "700", fontSize: "18px", padding: "24px" }}>
                {`${aStudentInvoice?.payment_method?.[0]?.currency || "NGN"} ${aStudentInvoice?.total}`}
              </TableCell>
            </TableRow>
          </TableFooter>
        </GridTable>
      </TableContainer>
      <div className={`${classes.previewsubheader} text-align-left margin-top-30 `}>
        <div>
          <p>Description:</p>
          <p>{aStudentInvoice?.description || "--/--"}</p>
        </div>
      </div>
    </div>
  );
};

export default ViewInvoice;
